// extracted by mini-css-extract-plugin
module.exports = {"loader":"a10a3f92e9--loader--oLxYu","skeleton-animation":"a10a3f92e9--skeleton-animation--jVza7"};